export function contactPhoneDigits(contact) {
  const normalized = String(contact?.phone_normalized || '').replace(/\D/g, '');
  if (normalized.length >= 10) return normalized;
  const cc = String(contact?.country_code || '').replace(/\D/g, '');
  const phone = String(contact?.phone || '').replace(/\D/g, '');
  if (!phone) return '';
  if (cc && !phone.startsWith(cc) && phone.length <= 12) return `${cc}${phone}`;
  return phone;
}

export function phonesMatch(a, b) {
  if (!a || !b) return false;
  if (a === b) return true;
  const [shorter, longer] = a.length <= b.length ? [a, b] : [b, a];
  return shorter.length >= 10 && longer.endsWith(shorter);
}

export function combineRecipients({
  savedCount = 0,
  selectedPhones = [],
  directNumbers = [],
}) {
  const directUnique = directNumbers.filter(
    (number) => !selectedPhones.some((phone) => phonesMatch(phone, number)),
  );
  return {
    savedCount,
    directCount: directNumbers.length,
    directUnique,
    duplicateCount: directNumbers.length - directUnique.length,
    total: savedCount + directUnique.length,
  };
}
